export const YEAR = "year";
export const QUARTER = "quarter";
export const MONTHLY = "monthly";

export const visualizationOptions = [
    {
        label: "Mensal",
        value: MONTHLY,
    },
    {
        label: "Trimestral",
        value: QUARTER,
    },
    {
        label: "Anual",
        value: YEAR,
    }   
];

function getMontList() {
    return {
        'janeiro': '1º Trimestre',
        'fevereiro': '1º Trimestre',
        'marco': '1º Trimestre',
        'abril': '2º Trimestre',
        'maio': '2º Trimestre',
        'junho': '2º Trimestre',
        'julho': '3º Trimestre',
        'agosto': '3º Trimestre',
        'setembro': '3º Trimestre',
        'outubro': '4º Trimestre',
        'novembro': '4º Trimestre',
        'dezembro': '4º Trimestre'
    };
}

export const groupCategoriesByQuarter = (data) => {
    var monthList = getMontList();
    const grouped = {};
    _.forEach(data, (entries, monthKey) => {
        const [rawMonth, year] = monthKey.split('/');
        const normalizedMonth = rawMonth.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        const quarter = monthList[normalizedMonth];
        if (!quarter) return;

        const quarterKey = `${quarter}/${year}`;
        if (!grouped[quarterKey]) grouped[quarterKey] = {};

        entries.forEach(entry => {
            const costCenter = entry.cost_center;

            if (!grouped[quarterKey][costCenter]) {
                grouped[quarterKey][costCenter] = {};
            }

            entry.categories.forEach(category => {
                if (!grouped[quarterKey][costCenter][category.name]) {
                    grouped[quarterKey][costCenter][category.name] = 0;
                }
                grouped[quarterKey][costCenter][category.name] += category.amount;
            });
        });
    });

    const result = {};
    _.forEach(grouped, (costCenters, quarterKey) => {
        result[quarterKey] = Object.entries(costCenters).map(([costCenter, categories]) => {
            return {
                cost_center: costCenter,
                categories: Object.entries(categories).map(([name, amount]) => ({
                    name,
                    amount
                }))
            };
        });
    });

    return result;
}

export const groupCostCentersByQuarter = (data) => {
    var monthList = getMontList();
    const grouped = {};
    _.forEach(data, (costCenters, monthKey) => {
        const [rawMonth, year] = monthKey.split('/');
        const normalizedMonth = rawMonth.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        const quarter = monthList[normalizedMonth];
        if (!quarter) return;

        const quarterKey = `${quarter}/${year}`;
        if (!grouped[quarterKey]) grouped[quarterKey] = {};

        costCenters.forEach(center => {
            const key = `${center.id}-${center.name}`;
            if (!grouped[quarterKey][key]) {
                grouped[quarterKey][key] = {
                    id: center.id,
                    name: center.name,
                    amount: 0
                };
            }
            grouped[quarterKey][key].amount += center.amount;
        });
    });

    const result = { };
    _.forEach(grouped, (centersMap, quarterKey) => {
        result[quarterKey] = Object.values(centersMap);
    });
    return result;
}